(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-result/assets/javascripts/ball-row-result-joker.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-result/assets/javascripts/ball-row-result-joker.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.result = svs.tur.ball.row.result || {};
class Joker extends svs.tur.ball.row.result.Default {
  constructor(options) {
    options.row = new svs.tur.ball.row.Joker(options);
    super(options);
  }
  classNames() {
    return ['ball-row-result-joker'];
  }
}
svs.tur.ball.row.result.Joker = Joker;

 })(window);